module.exports = __webpack_public_path__ + "static/img/7.6ce2ef1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/7.png
// module id = aIzp
// module chunks = 0